import React, { ReactElement } from 'react';
import Layout from '../../components/Layout';
import * as styles from '../../styles/projects.module.css';
import { graphql, Link } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { FileNode } from 'gatsby-plugin-image/dist/src/components/hooks';

interface Props {
  data: {
    projects: {
      nodes: IProjectItem[];
    };
    contact: {
      siteMetadata: {
        contact: string;
      };
    };
  };
}

export interface IProjectItem {
  frontmatter: {
    stack: string;
    title: string;
    slug: string;
    thumbImg: FileNode;
  };
  id: string;
}

export default function projects({ data }: Props): ReactElement {
  const projects = data.projects.nodes;
  const contact = data.contact.siteMetadata.contact;

  return (
    <Layout>
      <div className={styles.portfolio}>
        <h2>Portfolio</h2>
        <h3>Project & Websites I've Created</h3>
        <div className={styles.projects}>
          {projects.map((project) => {
            const image = getImage(project.frontmatter.thumbImg);
            return (
              <Link to={'/projects/' + project.frontmatter.slug} key={project.id}>
                <div>
                  <GatsbyImage image={image!} alt={project.frontmatter.title} />
                  <h3>{project.frontmatter.title}</h3>
                  <p>{project.frontmatter.stack}</p>
                </div>
              </Link>
            );
          })}
        </div>
        <p>Like what you see? Email me at {contact} for a quote!</p>
      </div>
    </Layout>
  );
}

export const query = graphql`
  query ProjectsPage {
    projects: allMarkdownRemark(sort: { fields: frontmatter___date, order: DESC }) {
      nodes {
        frontmatter {
          stack
          title
          slug
          thumbImg {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED, width: 220, height: 200, placeholder: BLURRED)
            }
          }
        }
        id
      }
    }

    contact: site {
      siteMetadata {
        contact
      }
    }
  }
`;
